export default __webpack_public_path__ + "static/media/Your-query-details-will-be-gathered.e1048f8a.png";